import { Prop, Component, Vue } from 'vue-property-decorator';
import { CreateElement, VNodeData } from 'vue';
import warning from 'warning';

const MEDIA_COMPONENTS = ['video', 'audio', 'picture', 'iframe', 'img'];

@Component
export default class ClCardMedia extends Vue {
  /**
   * The html tag of the node.
   */
  @Prop({
    type: String,
    default: 'div'
  })
  public component!: string;

  /**
   * Image to be displayed as a background image.
   * Either `image` or `src` prop must be specified.
   * Note that caller must specify height otherwise the image will not be visible.
   */
  @Prop(String)
  public image!: string;

  /**
   * An alias for `image` property.
   * Available only with media components.
   * Media components: `video`, `audio`, `picture`, `iframe`, `img`.
   */
  @Prop(String)
  public src!: string;

  public style!: object;

  render(h: CreateElement) {
    warning(Boolean(this.image), 'CLUI: `image` property must be specified.');
    const isMediaComponent: boolean = MEDIA_COMPONENTS.includes(this.component);
    const data: VNodeData = {
      class: {
        'cl-card-media': true,
        'cl-card-media--with-media-component': isMediaComponent
      },
      attrs: {
        src: isMediaComponent ? this.image || this.src : undefined
      }
    };
    if (!isMediaComponent && this.image) {
      data.style = {
        backgroundImage: `url(${this.image})`,
        ...this.style
      };
    } else {
      data.style = this.style;
    }
    return h(this.component, data, this.$slots.default);
  }
}
